import React, { useEffect, useState } from 'react';
import { Card, Table, Button, Space, Tag, message, Form, Input } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { getNotices, updateNotice, updateNoticeStatus, Notice } from '../../services/notice';

const { TextArea } = Input;

const AnnouncementManagement: React.FC = () => {
  const [form] = Form.useForm();
  const [notices, setNotices] = useState<Notice[]>([]);
  const [loading, setLoading] = useState(false);

  // 获取公告列表
  const fetchNotices = async () => {
    try {
      setLoading(true);
      const response = await getNotices();
      console.log('公告列表响应:', response);
      if (response.code === 0) {
        setNotices(Array.isArray(response.data) ? response.data : []);
      } else {
        message.error(response.message || '获取公告列表失败');
        setNotices([]);
      }
    } catch (error) {
      console.error('获取公告列表失败:', error);
      message.error('获取公告列表失败');
      setNotices([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotices();
  }, []);

  // 处理表单提交
  const handleSubmit = async (values: any) => {
    try {
      setLoading(true);
      await updateNotice(values.type, values.content);
      message.success('更新公告成功');
      fetchNotices();
      form.resetFields();
    } catch (error) {
      message.error('更新公告失败');
    } finally {
      setLoading(false);
    }
  };

  // 处理状态切换
  const handleStatusChange = async (type: number, status: number) => {
    try {
      await updateNoticeStatus(type, status);
      message.success('更新状态成功');
      fetchNotices();
    } catch (error) {
      message.error('更新状态失败');
    }
  };

  const columns = [
    {
      title: '公告类型',
      dataIndex: 'type',
      key: 'type',
      render: (type: number) => (
        <Tag color={type === 1 ? 'blue' : 'green'}>
          {type === 1 ? '滚动公告' : '固定公告'}
        </Tag>
      ),
    },
    {
      title: '公告内容',
      dataIndex: 'content',
      key: 'content',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status: number, record: Notice) => (
        <Tag color={status === 1 ? 'success' : 'error'}>
          {status === 1 ? '启用' : '禁用'}
        </Tag>
      ),
    },
    {
      title: '创建时间',
      dataIndex: 'addtime',
      key: 'addtime',
      render: (timestamp: number) => (
        <span>{new Date(timestamp * 1000).toLocaleString()}</span>
      ),
    },
    {
      title: '更新时间',
      dataIndex: 'updatetime',
      key: 'updatetime',
      render: (timestamp: number) => (
        <span>{timestamp ? new Date(timestamp * 1000).toLocaleString() : '-'}</span>
      ),
    },
    {
      title: '操作',
      key: 'action',
      render: (_: any, record: Notice) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => {
              form.setFieldsValue({
                type: record.type,
                content: record.content,
              });
            }}
          >
            编辑
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Card title="公告管理" style={{ marginBottom: 24 }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{ type: 1 }}
        >
          <Form.Item
            name="type"
            label="公告类型"
            rules={[{ required: true }]}
          >
            <Input disabled />
          </Form.Item>
          <Form.Item
            name="content"
            label="公告内容"
            rules={[{ required: true, message: '请输入公告内容' }]}
          >
            <TextArea rows={4} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              更新公告
            </Button>
          </Form.Item>
        </Form>
      </Card>

      <Card title="公告列表">
        <Table
          columns={columns}
          dataSource={notices}
          rowKey="id"
          loading={loading}
        />
      </Card>
    </div>
  );
};

export default AnnouncementManagement; 